import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import { FillTypes} from '@PosterWhiteboard/classes/fill.class';

interface BaseFillColorOptionsProps {
  fillObject: FillObject;
  onOpenColorPanel(colorIndex: number): void;
}

export function BaseFillColorOptions({...props}: BaseFillColorOptionsProps): ReactElement | null {
  const getColorLabel = (index: number): string => {
    if (props.fillObject.fillType === FillTypes.SOLID) {
      return window.i18next.t('pmwjs_color');
    }

    return window.i18next.t(index === 0 ? 'pmwjs_color_one' : 'pmwjs_color_two');
  };

  const getColorFillOption = (): ReactElement | Array<ReactElement> => {
    const reverseArray = props.fillObject.fillColor;
    return reverseArray.map((color, index) => {
      return (
        <ContextualMenuColorFillOption
          id={`text-fill-color-${index}`}
          key={`text-fill-color-${index}`}
          label={getColorLabel(index)}
          className="_fit-height spacing-m-b-4"
          data={[
            {
              id: `color-fill-object-${index}`,
              color: getColorObjectArrayFromFillColor([color]),
            },
          ]}
          onClick={(): void => {
            props.onOpenColorPanel(index);
          }}
        />
      );
    });
  };

  const getOptions = (): ReactElement => {
    return <div className="flex-v-row _full-height flex-column-reverse">{getColorFillOption()}</div>;
  };

  return getOptions();
}
